import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';
import { GenericPageType01Component } from "./generic-page-type01/generic-page-type01.component";
import { PolicyPageData } from './generic-page.resolver';

@Component({
  selector: 'app-generic-page',
  standalone: true,
  imports: [CommonModule, GenericPageType01Component],
  templateUrl: './generic-page.component.html',
  styleUrl: './generic-page.component.scss'
})
export class GenericPageComponent implements OnInit {

  public view: any = {};
  /** Resolved policy data (site, contentBySection, page) when route resolver ran; used for SSR and fast first paint */
  policyData: PolicyPageData | null = null;

  constructor(
    private _tfmService: TFMService,
    private route: ActivatedRoute,
    private title: Title,
    private metaService: Meta
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(res => {
      this.view.slug = (res['slug'] || '').toLowerCase();
    });

    const resolved = this.route.snapshot.data['policyData'] as PolicyPageData | null;
    if (resolved) {
      this.policyData = resolved;
      this.view.site = resolved.site;
      this.view.page = resolved.contentBySection;
      if (this.view.page?.content && this.view.site) {
        this.title.setTitle(this.view.page.content.name + ' - ' + this.view.page.name);
        this.metaService.updateTag({ name: 'description', content: this.view.page.content.seo?.description ?? '' });
        this.metaService.updateTag({ name: 'keywords', content: this.view.page.content.seo?.keywords ?? '' });
      }
      return;
    }

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      if (this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }
    });

    if (this.view.slug) {
      this._tfmService.getContentBySection(this.view.slug).then(res => {
        this.view.page = res;
        if (this.view.page?.content && this.view.site) {
          this.title.setTitle(this.view.page.content.name + ' - ' + this.view?.page.name);
          this.metaService.updateTag({ name: 'description', content: this.view.page.content.seo?.description ?? '' });
          this.metaService.updateTag({ name: 'keywords', content: this.view.page.content.seo?.keywords ?? '' });
        }
      });
    }
  }
}
